import request from '@/server/request'

export default {
  async loadSensorsData ({ rootGetters }) {
    return request({ entity: 'smart_house.sensors', action: 'load' }, rootGetters['user/getAccessToken'])
  }
}
